


const useCarritoStore = defineStore('carrito', () => {
  // state= 
  const carrito = ref({
      id:null,
      cliente_id:null,
      cliente:null,
      total:0,
      productos:[],
  });

  const carritos = ref([]);

  //  getters
  const draft = computed(() => clone(carrito.value));

  // methods

  const clear = () => {
    carrito.value = {
      id:null,
      cliente_id:null,
      cliente:null,
      total:0,
      productos:[],
    };
  };

    const setCarrito = (carr) => {
      if(carr){
        carrito.value = carr
      }
    };

    const update = (carr) => {
      if(carr){
        carrito.value = carr
      }
    };

    const agregarProducto = (prod) => {
      if(prod){
        carrito.value.productos.push(prod)
      }
    };

    const setTotal = (total) => {
      carrito.value.total = total
    };
    
    const removerProducto = (producto_id) => {
      carrito.value.productos = carrito.value.productos.filter(p => p.id !== producto_id)
    };

    const fetch = async (carrito_id) => {
      try {
        const { data } = await axios.get(
          `/api/carrito-compras/${carrito_id}/fetch-data`
        );
        setCarrito(data);
        return data;
      } catch (error) {
        console.error("Error fetching carrito:", error);
        throw error;
      }
      // return new Promise((resolve, reject) => {
      //   axios.get(`/api/carrito-compras/${carrito_id}/fetch-data`).then(({data}) => {
      //     setCarrito(data);
      //     resolve(data)
      //   }).catch(e => reject(e))
      // })
    };


    const fetchDataProductos = (datos) => {
      return new Promise((resolve, reject) => {
        axios.post(`/api/carrito-compras/fetch-data-productos`,datos)
        .then(({data}) => {
          resolve(data)
        }).catch(e => reject(e));

      })
    };

    const fetchCarritoCliente = (cliente_id) => {
      return new Promise((resolve, reject) => {
        
        axios.get(`/api/carrito-compras/clientes/${cliente_id}/fetch-data`).then(({data}) => {
          setCarrito(data);
          resolve(data)
        }).catch(e => reject(e))

      })
    };


    const guardar = (datos) => {
      return new Promise((resolve, reject) => {
        if(datos.id){
          axios.put(`/api/carritos/${datos.id}`,datos).then(({data}) => resolve(data)).catch(e => reject(e))
        }else{
          axios.post(`/api/carritos`,datos).then(({data}) => resolve(data)).catch(e => reject(e))
        }
      })
    };


    const addProducto = (datos) => {
      return new Promise((resolve, reject) => {
        axios.post(`/api/carrito-compras/add-producto`,datos).then(({data}) => {
          if(data.result){
            setCarrito(data.carrito);
          }
          resolve(data)
        }).catch(e => reject(e))
      })
    };


    const remover = (producto_id) => {
       return new Promise((resolve, reject) => {
        axios.get(`/api/carrito-compras/${carrito.value.id}/producto/${producto_id}/remove`).then(({data}) => {
         if(data.result){
          removerProducto(producto_id);
         }
         resolve(data);
        }).catch(e => reject(e))
      })
    };
    

    const eliminar = (carrito_id) => {
        return new Promise((resolve, reject) => {
          axios.delete(`/api/carritos/${carrito_id}`).then(({data}) => resolve(data)).catch(e => reject(e))
        })
    };

    return {
      // state 
      carrito,
      carritos,
      draft,
      //methods
      clear,
      setCarrito,
      update,
      agregarProducto,
      setTotal,
      removerProducto,
      fetch,
      fetchDataProductos,
      fetchCarritoCliente,
      guardar,
      addProducto,
      remover,
      eliminar
    };

});

export default useCarritoStore;